var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconsGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons",
    clipPath: "url(#clip0_932_1591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50786 0C4.25026 0 0 4.28159 0 9.57851C0 13.8126 2.72329 17.3967 6.50121 18.6652C6.97355 18.7606 7.14656 18.4591 7.14656 18.2055C7.14656 17.9835 7.13099 17.2223 7.13099 16.4292C4.48614 17.0003 3.93537 15.2874 3.93537 15.2874C3.51032 14.1773 2.88054 13.892 2.88054 13.892C2.01488 13.3052 2.94359 13.3052 2.94359 13.3052C3.90384 13.3687 4.40771 14.2885 4.40771 14.2885C5.2576 15.7473 6.62713 15.3351 7.17809 15.0813C7.25672 14.4628 7.50875 14.0347 7.77635 13.7968C5.66688 13.5748 3.44746 12.7502 3.44746 9.07094C3.44746 8.02429 3.82502 7.16797 4.42327 6.50199C4.32889 6.26416 3.99823 5.28076 4.51786 3.96456C4.51786 3.96456 5.32066 3.71078 7.1308 4.94777C7.90578 4.7381 8.70501 4.63144 9.50786 4.63054C10.3107 4.63054 11.129 4.74167 11.8847 4.94777C13.6951 3.71078 14.4979 3.96456 14.4979 3.96456C15.0175 5.28076 14.6866 6.26416 14.5923 6.50199C15.2063 7.16797 15.5683 8.02429 15.5683 9.07094C15.5683 12.7502 13.3488 13.5588 11.2236 13.7968C11.57 14.0981 11.869 14.6689 11.869 15.5729C11.869 16.8574 11.8534 17.8883 11.8534 18.2053C11.8534 18.4591 12.0266 18.7606 12.4987 18.6654C16.2767 17.3965 19 13.8126 19 9.57851C19.0155 4.28159 14.7497 0 9.50786 0Z",
    fill: "#24292F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_932_1591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconsGithub);
export default __webpack_public_path__ + "static/media/Social-Icons--Github.340c45ef39c3356d33ec298d98f2df07.svg";
export { ForwardRef as ReactComponent };